import type { InvoiceDetailFile } from './useQueryInvoiceDetail';

import { type UUID } from '~/types/common';

import { fetchInvoiceFileById } from './useQueryInvoiceFileById';

/**
 * Fetches one file listed in invoice detail data.
 *
 * @param invoiceId - The invoice ID.
 * @param file - The file entry from invoice detail data.
 * @returns The requested file as a Blob.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/get_invoice_file_invoices__invoice_id__file_get
 */
export function fetchInvoiceDetailFile(
  invoiceId: UUID,
  file: InvoiceDetailFile,
): Promise<Blob> {
  return fetchInvoiceFileById({ fileId: file.id, invoiceId });
}
